import { SET_API_BASE_AUTH_ADDRESS } from "../actions/types";

const updateAddresses = (state, action) => {
  if (!state) {
    return {
      apiBase: "",
      authenticationAddress: "",
      healthCheckApiBase: "",
      isDev: false,
      isTestingMode: false,
    };
  }

  switch (action.type) {
    case SET_API_BASE_AUTH_ADDRESS:
      return {
        apiBase: action.payload.apiBase,
        authenticationAddress: action.payload.authenticationAddress,
        healthCheckApiBase: action.payload.healthCheckApiBase,
        isDev: !!action.payload.isDev,
      };
    default:
      return {
        ...state.addresses,
      };
  }
};

export default updateAddresses;
